import React, { useState, useRef, useEffect } from 'react'
import { ChevronDown, ChevronUp, Plus } from 'lucide-react'
import { StyledCard, CardTitle, CollapsePanelHeader, FamilyTag, RemoveTagButton } from '../style'
import cross from '../../../../../assets/stock/FiltersHeader/cross.svg'

export interface ColorItem {
  id: number
  name: string
  hex?: string
  pantoneCode?: string
}

interface Props {
  label?: string
  allColors: ColorItem[]
  selectedColors: ColorItem[]
  onAdd: (color: ColorItem) => void
  onRemove: (id: number) => void
  disabled?: boolean
}

const Colors: React.FC<Props> = ({
  label = 'COR MOSTRUÁRIO',
  allColors,
  selectedColors,
  onAdd,
  onRemove,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showSelect, setShowSelect] = useState(false)
  const selectRef = useRef<HTMLSelectElement>(null)

  const availableColors = allColors.filter(
    (c) => !selectedColors.some((sc) => sc.id === c.id)
  )

  useEffect(() => {
    if (showSelect && selectRef.current) {
      selectRef.current.focus()
    }
  }, [showSelect])

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(e.target.value)
    if (!id) return
    const col = allColors.find((c) => c.id === id)
    if (col) {
      onAdd(col)
    }
    e.target.value = ''
    setShowSelect(false)
  }

  return (
    <StyledCard>
      <CollapsePanelHeader
        $open={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <CardTitle>Cores</CardTitle>
        {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </CollapsePanelHeader>

      {isOpen && (
        <div>
          <span
            style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 700,
              color: '#9ca3af',
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              marginBottom: 10,
            }}
          >
            {/* {label} */}
          </span>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
            {selectedColors.map((c) => (
              <FamilyTag key={c.id}>
                {c.hex && (
                  <span
                    style={{
                      display: 'inline-block',
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      backgroundColor: c.hex.startsWith('#') ? c.hex : `#${c.hex}`,
                      border: '1px solid rgba(0,0,0,0.15)',
                      flexShrink: 0,
                    }}
                  />
                )}
                <span style={{ fontSize: 13 }}>{c.name}</span>
                <RemoveTagButton
                  type='button'
                  onClick={() => onRemove(c.id)}
                  disabled={disabled}
                >
                  <img src={cross} alt='Remover' />
                </RemoveTagButton>
              </FamilyTag>
            ))}

            {showSelect ? (
              <select
                ref={selectRef}
                defaultValue=''
                onChange={handleSelectChange}
                onBlur={() => setShowSelect(false)}
                disabled={disabled || availableColors.length === 0}
                style={{
                  padding: '5px 12px',
                  borderRadius: 100,
                  border: '1px solid #0090d3',
                  fontSize: 13,
                  color: '#0090d3',
                  outline: 'none',
                  cursor: 'pointer',
                  backgroundColor: '#fff',
                }}
              >
                <option value=''>Selecione uma cor</option>
                {availableColors.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            ) : (
              <button
                type='button'
                onClick={() => setShowSelect(true)}
                disabled={disabled || availableColors.length === 0}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  padding: '5px 12px',
                  borderRadius: 100,
                  border: '1px solid #0090d3',
                  background: '#fff',
                  color: '#0090d3',
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: disabled || availableColors.length === 0 ? 'not-allowed' : 'pointer',
                  opacity: disabled || availableColors.length === 0 ? 0.5 : 1,
                }}
              >
                <Plus size={13} />
                Adicionar cor
              </button>
            )}
          </div>
        </div>
      )}
    </StyledCard>
  )
}

export default Colors
